import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SideBar = ({ navItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <div
      style={{
        width: isOpen ? '240px' : '80px',
        transition: 'width 0.3s',
        background: 'linear-gradient(180deg, rgba(212, 69, 27, 0) 0%, #D4451B 100%), #FF9B45',
        color: '#FFECC8',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        paddingTop: '80px', // top spacing for TopBar
      }}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <li
              key={item.path}
              style={{
                padding: '20px 18px',
                backgroundColor: isActive ? 'rgba(249, 242, 223, 0.1)' : 'transparent',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: isOpen ? '16px' : '0px',
                justifyContent: isOpen ? 'flex-start' : 'center',
                borderLeft: isActive ? '4px solid #F9F2DF' : '4px solid transparent',
              }}
              title={!isOpen ? item.label : undefined} // tooltip when collapsed
            >
              <Link
                to={item.path}
                style={{
                  textDecoration: 'none',
                  color: isActive ? '#F9F2DF' : '#FFECC8',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  width: '100%',
                  fontSize: '18px',
                  fontWeight: isActive ? 'bold' : 'normal',
                }}
              >
                <span
                  style={{
                    fontSize: '24px',
                    minWidth: '28px',
                    textAlign: 'center',
                  }}
                >
                  {item.icon || '🔹'}
                </span>
                {isOpen && <span>{item.label}</span>}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SideBar;
